import React, { useEffect, useState } from 'react';

import { 
  Character,
  CharacterSheetInterface,
  TransformInstance,
} from "@dndModels";
import { isSizeType, SizeType } from "@dndModels/Types";
import { SIZE_OPTIONS } from "@dndModels/Constants";

import CommonUtilities from "@utilities/common_utilities";

import SelectStringBox from "@components/input/selects/SelectStringBox";
import DandDCharacterUtilities from "@dndUtilities/char_utilities";
import CenteredMenu from "@components/input/menus/CenteredMenu";
import FlexBox from '@components/layout/FlexBox';
// import FloatMenu from '../../../../../components/input/menus/FloatMenu';

interface Props {
  char: Character;
  char_int: CharacterSheetInterface;
  disabled: boolean;
  // onChange: () => void;
}

const common_util = CommonUtilities.getInstance();
const char_util = DandDCharacterUtilities.getInstance();

export default function CharacterSizeButton({ 
  char,
  char_int,
  disabled,
  // onChange,
}: Props) {
  const [fetched, setFetched] = useState(false);
  const [reloading, setReloading] = useState(false);
  const char_int_type = char_int instanceof TransformInstance ? "Transform" : "Character";
  const [view, setView] = useState(char.customizations.overrides.size === undefined ? "Options" : "Override");
  const [override_size, setOverrideSize] = useState(char.customizations.overrides.size === undefined ? "Don't Override" : common_util.size_map[char.customizations.overrides.size]);
  const [default_size, setDefaultSize] = useState<string>("Medium");
  const [size_options, setSizeOptions] = useState<string[]>([]);
  const [transform_default_size, setTransformDefaultSize] = useState<string>("Medium");
  const [transform_size_options, setTransformSizeOptions] = useState<string[]>([]);

  useEffect(() => {
    if (!fetched) {
      setFetched(true);
      
      // debugger;
      if (char_int.mind.size_option_features.length > 0) {
        // Put all the options together.
        let ignore_char_size = true;
        let new_size_options = [...char_int.mind.size_options];
        let new_default_size: SizeType = 0;
        for (const so of char_int.mind.size_option_features) {
          if (!so.ignore_char_size) {
            ignore_char_size = false;
          }
          if (so.default_size > 0) {
            new_default_size = so.default_size;
          }
          new_size_options.push(...so.size_options);
        }
        if (!ignore_char_size) {
          new_size_options.push(char_int.mind.base_size);
        }
        new_size_options = new_size_options.filter(o => o !== 0); // Just to be certain
        new_size_options = common_util.unique_array(new_size_options);
        // if (character.overriding_size > 0) {
        //   if (size_options.includes(character.overriding_size)) {
        //     default_size = character.overriding_size;
        //   }
        // }
        if (new_default_size === 0) {
          if (new_size_options.includes(char_int.mind.base_size)) {
            new_default_size = char_int.mind.base_size;
          } else {
            // Get the closest included size to it
            const min = Math.min(...new_size_options);
            const max = Math.max(...new_size_options);
            if (char_int.mind.base_size < min) {
              new_default_size = min as SizeType;
            } else if (char_int.mind.base_size > max) {
              new_default_size = max as SizeType;
            } else {
              // It's somewhere in the middle.  It's weird that it's not included as an option.  Probably will never actually come here.  Just make it min.
              new_default_size = min as SizeType;
            }
          }
        }
        setSizeOptions(common_util.get_size_strings(new_size_options.sort()));
        setDefaultSize(common_util.size_map[new_default_size]);
      } else if (char_int.mind.size_options.length > 0) {
        // Put all the options together.
        let new_size_options = [...char_int.mind.size_options];
        let new_default_size: SizeType = 0;
        new_size_options = new_size_options.filter(o => o !== 0); // Just to be certain
        new_size_options = common_util.unique_array(new_size_options);
        // if (character.overriding_size > 0) {
        //   if (size_options.includes(character.overriding_size)) {
        //     default_size = character.overriding_size;
        //   }
        // }
        if (new_default_size === 0) {
          if (new_size_options.includes(char_int.mind.base_size)) {
            new_default_size = char_int.mind.base_size;
          } else {
            // Get the closest included size to it
            const min = Math.min(...new_size_options);
            const max = Math.max(...new_size_options);
            if (char_int.mind.base_size < min) {
              new_default_size = min as SizeType;
            } else if (char_int.mind.base_size > max) {
              new_default_size = max as SizeType;
            } else {
              // It's somewhere in the middle.  It's weird that it's not included as an option.  Probably will never actually come here.  Just make it min.
              new_default_size = min as SizeType;
            }
          }
        }
        setSizeOptions(common_util.get_size_strings(new_size_options.sort()));
        setDefaultSize(common_util.size_map[new_default_size]);
      } else if (char.spirit.race.source) {
        if (char.spirit.race.source.sizes.length === 1 && char.spirit.race.source.sizes[0] === 7) {
          if (char.spirit.race.char_subrace && char.spirit.race.char_subrace.source) {
            setDefaultSize(common_util.size_map[char.base_size]);
            setSizeOptions(common_util.get_size_strings(char.spirit.race.char_subrace.source.sizes.sort()));
          }
        } else {
          setDefaultSize(common_util.size_map[char.base_size]);
          setSizeOptions(common_util.get_size_strings(char.spirit.race.source.sizes.sort()));
        }
      }
      if (char_int instanceof TransformInstance && char_int.spirit.transform) {
        let new_size_options: number[] = [];
        // if (char_interface.spirit.transform.size.use_options && char_interface.spirit.transform.size.options) {
        //   new_size_options = [...char_interface.spirit.transform.size.options];
        // } else {
          new_size_options.push(char_int.base_size);
        // }
        setTransformSizeOptions(common_util.get_size_strings(new_size_options.sort()));
        setTransformDefaultSize(common_util.size_map[new_size_options[0]]);
      }
    }
  }, [fetched, char_int, char]);

  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading, setReloading]);

  const renderView = () => {
    if (view === "Override") {
      return (
        <FlexBox>
          <SelectStringBox 
            name="Base Size"
            options={SIZE_OPTIONS}
            extra_options={["Don't Override"]}
            value={ override_size } 
            disabled={ disabled }
            onChange={ async (changed: string) => {
              setOverrideSize(changed);
              if (changed === "Don't Override") {
                delete char.customizations.overrides.size;
              } else {
                const size = +changed;
                if (isSizeType(size)) {
                  char.customizations.overrides.size = size;
                }
              }
              char.changed();
              char.subscription_holder.recalculate();
            }}
          />
        </FlexBox>
      );
    } else {
      switch(char_int_type) {
        case "Character": return renderCharacterSize();
        default: return renderTransformSize();
      }
    }
  }

  const renderCharacterSize = () => {
    if (char_int.mind.size_option_features.length > 0 || char_int.mind.size_options.length > 0) {
      return (
        <FlexBox>
          <SelectStringBox 
            name="Base Size"
            options={size_options}
            value={default_size} 
            disabled={ disabled }
            onChange={async (changed: string) => {
              setDefaultSize(changed);
              const base_size = common_util.size_to_num_map[changed];
              char_int.spirit.base_size = base_size;
              char.changed();
              char.subscription_holder.recalculate();
            }}
          />
        </FlexBox>
      );
    } else {
      if (size_options.length === 1) {
        return (
          <FlexBox>
            <span style={{ fontWeight: "bold" }}>Base Size: { size_options[0] }</span>
          </FlexBox>
        );
      } else {
        return (
          <FlexBox>
            <SelectStringBox 
              name="Base Size"
              options={size_options}
              value={default_size} 
              disabled={ disabled }
              onChange={async (changed: string) => {
                setDefaultSize(changed);
                const base_size = common_util.size_to_num_map[changed];
                char_int.spirit.base_size = base_size;
                char.changed();
                char.subscription_holder.recalculate();
              }}
            />
          </FlexBox>
        );
      }
    }
  }

  const renderTransformSize = () => {
    if (char_int instanceof TransformInstance && char_int.spirit.transform) {
      return (
        <FlexBox>
          { transform_size_options.length === 1 ?
            <span style={{ fontWeight: "bold" }}>Base Size: { transform_default_size }</span>
          :
            <SelectStringBox 
              name="Base Size"
              options={transform_size_options}
              value={transform_default_size} 
              disabled={ disabled }
              onChange={async (changed: string) => {
                setTransformDefaultSize(changed);
                const base_size = common_util.size_to_num_map[changed];
                char_int.base_size = base_size;
                char.changed();
                char.subscription_holder.recalculate();
              }}
            />
          }
        </FlexBox>
      );
    }
    return null;
  }
  
  const renderModifier = () => {
    // console.log(`Base Size: ${char_interface.base_size}`);
    // console.log(`Mod: ${char_interface.size_modifier}`);
    // console.log(`Use: ${char_interface.use_size}`);
    // console.log(`Override: ${char_interface.overriding_size}`);
    if (char_int.mind.size_modifier !== 0) {
      const diff = char_int.mind.size_modifier;
      return (
        <FlexBox>
          Size is { diff > 0 ? `increased` : `decreased` } { diff }size { diff > 1 || diff < -1 ? "categories" : "category" }
        </FlexBox>
      );
    }
    return null;
  }

  // const options = ["Character","Transform"];
  return (
    <FlexBox direction="column">
      <FlexBox className="centered header">
        Manage Size
      </FlexBox>
      <FlexBox>
        <CenteredMenu
          options={["Options","Override"]}
          selected={view}
          onSelect={setView}
        />
      </FlexBox>
      { renderView() }
      { renderModifier() }
    </FlexBox>
  );
}
